const pdfBlocks = document.querySelectorAll("[data-pdf]");

for (const pdfBlock of pdfBlocks) {
    const pdfLink = pdfBlock.querySelector("[data-pdf-link]");
    const pdfCanvas = pdfBlock.querySelector("[data-pdf-canvas]");
    const href = pdfLink.getAttribute("href");

    const scale = 1;

    pdfjsLib.getDocument(href).promise.then(function(pdf) {
        const thePdf = pdf;
        renderPage(thePdf, 1, pdfCanvas, scale);
    });

    function renderPage(thePdf, pageNumber, canvas, scale) {
        thePdf.getPage(pageNumber).then(function(page) {
            const viewport = page.getViewport({ scale: scale });
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            const pageRenderingContext = canvas.getContext("2d");
            const renderTask = page.render({
                canvasContext: pageRenderingContext,
                viewport: viewport
            });
        });
    }
}
